var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect5, _rect6, _rect7, _path19, _path20, _rect8, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect9, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFuny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 380,
    viewBox: "0 0 346 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 186,
    height: 260,
    rx: 15,
    fill: "white",
    stroke: "#F3F3F3",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 134,
    width: 128,
    height: 16,
    rx: 4,
    fill: "#F5F5F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 160,
    width: 84,
    height: 16,
    rx: 4,
    fill: "#F5F5F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 164,
    height: 102,
    rx: 16,
    fill: "#F6E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.514 67.6636L117.877 65.1323C117.582 64.8494 117.19 64.6916 116.781 64.6916H109.082C108.208 64.6916 107.5 65.3999 107.5 66.2736V83.1486C107.5 84.0223 108.208 84.7306 109.082 84.7306H119.418C120.292 84.7306 121 84.0223 121 83.1486V68.8048C121 68.3741 120.824 67.9619 120.514 67.6636Z",
    fill: "#E573AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.988 72.958C114.115 72.958 113.406 73.6663 113.406 74.54V84.665H116.57V74.54C116.57 73.6663 115.862 72.958 114.988 72.958Z",
    fill: "#D8619C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.918 64.6916H71.2188C70.8104 64.6916 70.4177 64.8494 70.1231 65.1323L67.4864 67.6636C67.1757 67.9619 67 68.3741 67 68.8048V83.1486C67 84.0223 67.7083 84.7306 68.582 84.7306H78.918C79.7917 84.7306 80.5 84.0223 80.5 83.1486V66.2736C80.5 65.3999 79.7917 64.6916 78.918 64.6916Z",
    fill: "#FF80BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0117 72.958C72.138 72.958 71.4297 73.6663 71.4297 74.54V84.665H74.5938V74.54C74.5938 73.6663 73.8854 72.958 73.0117 72.958Z",
    fill: "#E573AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.271 54.9646L94.8062 47.4449C94.3177 47.1718 93.7212 47.1774 93.2378 47.4595L79.703 55.3538C79.2169 55.6373 78.918 56.1576 78.918 56.7203V68.9105L94 76.2933L109.067 68.9105L109.082 56.3458C109.082 55.7726 108.772 55.2441 108.271 54.9646Z",
    fill: "#FFDD4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.271 54.9647L94.8061 47.445C94.5558 47.3051 94.2772 47.2389 94 47.245V76.2934L109.067 68.9106L109.082 56.3459C109.082 55.7727 108.772 55.2442 108.271 54.9647Z",
    fill: "#FCB637"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55.4103C93.1263 55.4103 92.418 56.1186 92.418 56.9923V57.8361C92.418 58.7098 93.1263 59.4181 94 59.4181C94.8737 59.4181 95.582 58.7098 95.582 57.8361V56.9923C95.582 56.1186 94.8737 55.4103 94 55.4103Z",
    fill: "#C975F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55.4103V59.4181C94.8737 59.4181 95.582 58.7098 95.582 57.8361V56.9923C95.582 56.1186 94.8737 55.4103 94 55.4103Z",
    fill: "#A04CD9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 62.1603H87.25C86.3763 62.1603 85.668 62.8686 85.668 63.7423V72.5271C85.668 73.4008 86.3763 74.1092 87.25 74.1092H100.75C101.624 74.1092 102.332 73.4008 102.332 72.5271V63.7423C102.332 62.8686 101.624 62.1603 100.75 62.1603Z",
    fill: "#FCB637"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 62.1603H94V74.1092H100.75C101.624 74.1092 102.332 73.4008 102.332 72.5271V63.7423C102.332 62.8686 101.624 62.1603 100.75 62.1603Z",
    fill: "#F79537"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.067 68.9103H99.2734C98.9142 68.9103 98.5656 69.0325 98.2851 69.257L94.0663 72.632C94.0429 72.6508 94.0221 72.6717 94 72.6915C93.9779 72.6716 93.957 72.6507 93.9337 72.632L89.7149 69.257C89.4344 69.0325 89.0859 68.9103 88.7266 68.9103H78.918V84.7306H109.082L109.067 68.9103Z",
    fill: "#C975F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84.7306H109.082L109.067 68.9103H99.2734C98.9142 68.9103 98.5656 69.0325 98.2851 69.257L94.0663 72.632C94.0429 72.6508 94.0221 72.6717 94 72.6915V84.7306Z",
    fill: "#A04CD9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 77.1768C99.8763 77.1768 99.168 77.8851 99.168 78.7588V84.665H102.332V78.7588C102.332 77.8851 101.624 77.1768 100.75 77.1768Z",
    fill: "#8A3CB8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.25 77.1768C86.3763 77.1768 85.668 77.8851 85.668 78.7588V84.665H88.832V78.7588C88.832 77.8851 88.1237 77.1768 87.25 77.1768Z",
    fill: "#A04CD9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.076 53.1114L96.4333 41.7062C96.4096 41.6918 96.3855 41.6779 96.361 41.6648C94.8508 40.8468 93.0565 40.8629 91.5613 41.7079C91.5452 41.717 91.5294 41.7263 91.5137 41.7359L72.9244 53.1114C72.1838 53.5647 71.9469 54.5302 72.3936 55.2748L74.9248 59.4937C75.1425 59.8564 75.4965 60.117 75.9077 60.2169C76.0311 60.2469 76.1565 60.2618 76.2814 60.2618C76.5727 60.2618 76.861 60.1813 77.113 60.0256L94.0333 49.5717L110.885 60.0241C111.245 60.2473 111.679 60.3171 112.091 60.2172C112.503 60.1176 112.858 59.8569 113.076 59.4937L115.607 55.2748C116.054 54.5302 115.817 53.5646 115.076 53.1114Z",
    fill: "#C975F4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.076 53.1115L96.4332 41.7064C96.4094 41.6919 96.3854 41.6781 96.3609 41.6649C95.6195 41.2633 94.8095 41.0639 94 41.0638V49.5924L94.0331 49.5719L110.885 60.0244C111.245 60.2476 111.679 60.3174 112.091 60.2175C112.503 60.1178 112.857 59.8571 113.075 59.494L115.607 55.275C116.054 54.5303 115.817 53.5647 115.076 53.1115Z",
    fill: "#A04CD9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74 205C74 198.373 79.3726 193 86 193H103C109.627 193 115 198.373 115 205V222C115 228.627 109.627 234 103 234H86C79.3726 234 74 228.627 74 222V205Z",
    fill: "#F6F6F6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.709 205.5C93.5373 205.5 92.4135 205.965 91.585 206.794C90.7565 207.622 90.291 208.746 90.291 209.918V210.887C89.2825 211.005 88.5 211.863 88.5 212.903V219.47C88.5 220.591 89.4088 221.5 90.5299 221.5H98.8881C100.009 221.5 100.918 220.591 100.918 219.47V212.903C100.918 211.863 100.135 211.005 99.1269 210.887V209.918C99.1269 208.746 98.6614 207.622 97.8329 206.794C97.0044 205.965 95.8807 205.5 94.709 205.5ZM97.4552 210.873V209.918C97.4552 209.19 97.1659 208.491 96.6509 207.976C96.1358 207.461 95.4373 207.172 94.709 207.172C93.9806 207.172 93.2821 207.461 92.7671 207.976C92.252 208.491 91.9627 209.19 91.9627 209.918V210.873H97.4552ZM91.1269 212.545L90.5299 212.545C90.332 212.545 90.1716 212.705 90.1716 212.903V219.47C90.1716 219.668 90.332 219.828 90.5299 219.828H98.8881C99.0859 219.828 99.2463 219.668 99.2463 219.47V212.903C99.2463 212.705 99.0859 212.545 98.8881 212.545L98.291 212.545H91.1269Z",
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 79,
    width: 186,
    height: 260,
    rx: 15,
    fill: "white",
    stroke: "#F3F3F3",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 212,
    width: 128,
    height: 16,
    rx: 4,
    fill: "#F5F5F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 238,
    width: 84,
    height: 16,
    rx: 4,
    fill: "#F5F5F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M231 283C231 276.373 236.373 271 243 271H260C266.627 271 272 276.373 272 283V300C272 306.627 266.627 312 260 312H243C236.373 312 231 306.627 231 300V283Z",
    fill: "#8C52FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M256.458 293.337L249.225 297.283C248.938 297.44 248.619 297.514 248.298 297.498C247.977 297.482 247.666 297.377 247.393 297.193C247.12 297.009 246.894 296.752 246.738 296.446C246.582 296.14 246.5 295.796 246.5 295.446V287.554C246.5 287.204 246.582 286.86 246.738 286.554C246.894 286.248 247.12 285.991 247.393 285.807C247.666 285.623 247.977 285.518 248.298 285.502C248.619 285.486 248.938 285.56 249.225 285.717L256.458 289.663C256.771 289.833 257.035 290.095 257.219 290.42C257.403 290.744 257.5 291.118 257.5 291.5C257.5 291.882 257.403 292.256 257.219 292.58C257.035 292.905 256.771 293.167 256.458 293.337Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 90,
    width: 164,
    height: 102,
    rx: 16,
    fill: "#E0FFF4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M261.084 123.279L255.615 166.688L252.034 166.293L248.452 165.898L248.011 121.838L255.039 114.001L261.084 123.279Z",
    fill: "#81DBBA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M254.007 121.111L252.034 166.293L248.452 165.898L248.011 121.838L254.007 121.111Z",
    fill: "#56AB8F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M255.039 114L254.007 121.111L261.083 123.279L255.039 114Z",
    fill: "#BDF2DF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M250.251 126.177L249.751 162.143L245.704 162.465L241.655 162.787L235.475 127.353L242.306 119.78L250.251 126.177Z",
    fill: "#ED3561"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M245.704 162.464L241.655 162.786L235.475 127.353L244.018 130.662L245.704 162.464Z",
    fill: "#CE2454"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M242.306 119.78L244.018 130.662L250.251 126.177L242.306 119.78Z",
    fill: "#F7638D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M272.317 134.067L262.435 167.309H254.844L254.818 167.5L253.801 167.309L253.005 167.16L254.91 143.695L255.189 140.245L255.94 131.002L266.294 120.961L272.317 134.067Z",
    fill: "#CF8BFC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M265.912 135.065L257.492 168L253.005 167.16L255.94 131.002L265.912 135.065Z",
    fill: "#9966CC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M272.316 134.067L265.912 135.065L266.293 120.961",
    fill: "#DFB3FC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M244.362 167.309H236.257L225.388 137.438L229.976 125.638L239.576 133.891L244.362 167.309Z",
    fill: "#CF8BFC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M240.163 166.39V166.391L236.276 167.362L225.388 137.438L229.976 125.638L232.861 137.178L240.163 166.39Z",
    fill: "#9966CC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M239.576 133.891L232.861 137.178L225.388 137.438L229.976 125.638L239.576 133.891Z",
    fill: "#DFB3FC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M232.861 137.178L225.388 137.438L229.976 125.638L232.861 137.178Z",
    fill: "#BD8BFC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M257.647 146.669L254.844 167.309H243.058L240.255 146.669L248.95 137.223L257.647 146.669Z",
    fill: "#F9D366"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M251.698 148.095L249.779 167.309H243.058L240.255 146.669L251.698 148.095Z",
    fill: "#DD8833"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M257.647 146.669L251.698 148.095L248.951 137.223",
    fill: "#FFDB82"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M233.123 117.92C232.673 117.92 232.308 117.555 232.308 117.104V114.942C232.308 114.491 232.673 114.126 233.123 114.126C233.574 114.126 233.939 114.491 233.939 114.942V117.104C233.939 117.555 233.574 117.92 233.123 117.92Z",
    fill: "#CF8BFC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M233.123 123.74C232.673 123.74 232.308 123.375 232.308 122.924V120.762C232.308 120.312 232.673 119.947 233.123 119.947C233.574 119.947 233.939 120.312 233.939 120.762V122.924C233.939 123.375 233.574 123.74 233.123 123.74Z",
    fill: "#CF8BFC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M237.115 119.749H234.953C234.502 119.749 234.137 119.384 234.137 118.933C234.137 118.483 234.502 118.118 234.953 118.118H237.114C237.565 118.118 237.93 118.483 237.93 118.933C237.93 119.384 237.565 119.749 237.115 119.749Z",
    fill: "#CF8BFC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M231.294 119.749H229.132C228.682 119.749 228.316 119.384 228.316 118.933C228.316 118.483 228.682 118.118 229.132 118.118H231.294C231.745 118.118 232.11 118.483 232.11 118.933C232.11 119.384 231.745 119.749 231.294 119.749Z",
    fill: "#CF8BFC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M273.806 119.334C273.355 119.334 272.99 118.969 272.99 118.518V116.356C272.99 115.906 273.355 115.541 273.806 115.541C274.257 115.541 274.622 115.906 274.622 116.356V118.518C274.622 118.969 274.257 119.334 273.806 119.334Z",
    fill: "#ED3561"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M273.806 125.154C273.355 125.154 272.99 124.789 272.99 124.339V122.177C272.99 121.726 273.355 121.361 273.806 121.361C274.257 121.361 274.622 121.726 274.622 122.177V124.339C274.622 124.789 274.257 125.154 273.806 125.154Z",
    fill: "#ED3561"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M277.797 121.164H275.635C275.184 121.164 274.819 120.798 274.819 120.348C274.819 119.897 275.184 119.532 275.635 119.532H277.797C278.247 119.532 278.612 119.897 278.612 120.348C278.612 120.798 278.247 121.164 277.797 121.164Z",
    fill: "#ED3561"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M271.976 121.164H269.814C269.364 121.164 268.999 120.798 268.999 120.348C268.999 119.897 269.364 119.532 269.814 119.532H271.976C272.427 119.532 272.792 119.897 272.792 120.348C272.792 120.798 272.427 121.164 271.976 121.164Z",
    fill: "#ED3561"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M272.405 157.188C271.954 157.188 271.589 156.823 271.589 156.372V154.21C271.589 153.76 271.954 153.394 272.405 153.394C272.855 153.394 273.22 153.76 273.22 154.21V156.372C273.221 156.823 272.855 157.188 272.405 157.188Z",
    fill: "#F9C941"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M272.405 163.008C271.954 163.008 271.589 162.643 271.589 162.192V160.031C271.589 159.58 271.954 159.215 272.405 159.215C272.855 159.215 273.22 159.58 273.22 160.031V162.192C273.221 162.643 272.855 163.008 272.405 163.008Z",
    fill: "#F9C941"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M276.396 159.017H274.234C273.783 159.017 273.418 158.652 273.418 158.202C273.418 157.751 273.783 157.386 274.234 157.386H276.396C276.846 157.386 277.211 157.751 277.211 158.202C277.211 158.652 276.846 159.017 276.396 159.017Z",
    fill: "#F9C941"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M270.575 159.017H268.413C267.963 159.017 267.598 158.652 267.598 158.202C267.598 157.751 267.963 157.386 268.413 157.386H270.575C271.026 157.386 271.391 157.751 271.391 158.202C271.391 158.652 271.026 159.017 270.575 159.017Z",
    fill: "#F9C941"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 301,
    width: 78,
    height: 78,
    rx: 15,
    fill: "white",
    stroke: "#F3F3F3",
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M173.636 340.1H178.364V349.771H173.636V340.1Z",
    fill: "#FFD60D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M176.021 340.1H178.365V349.771H176.021V340.1Z",
    fill: "#FFB92C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M180.708 350.883L178.364 347.659H173.636L171.292 350.883C171.137 351.097 171.114 351.38 171.234 351.616C171.354 351.852 171.596 352 171.861 352H180.139C180.404 352 180.646 351.852 180.766 351.616C180.886 351.38 180.863 351.097 180.708 350.883Z",
    fill: "#FFB92C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M185.422 328H166.578C166.19 328 165.875 328.315 165.875 328.703V334.488C165.875 334.793 166.071 335.063 166.361 335.157L169.432 336.152C169.78 339.469 172.593 342.062 176 342.062C179.407 342.062 182.22 339.469 182.568 336.152L185.639 335.157C185.929 335.063 186.125 334.792 186.125 334.488V328.703C186.125 328.315 185.81 328 185.422 328V328ZM167.281 329.406H169.396V334.662L167.281 333.977V329.406ZM184.719 333.977L182.604 334.662V329.406H184.719V333.977Z",
    fill: "#FFB92C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M185.422 328H176.021V342.062C179.419 342.052 182.221 339.462 182.568 336.152L185.639 335.157C185.929 335.063 186.126 334.792 186.126 334.488V328.703C186.126 328.315 185.811 328 185.422 328V328ZM184.719 333.977L182.605 334.662V329.406H184.719V333.977Z",
    fill: "#FF9100"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M178.365 347.659H176.021V352H180.14C180.404 352 180.646 351.852 180.766 351.616C180.886 351.38 180.864 351.097 180.709 350.883L178.365 347.659Z",
    fill: "#FF9100"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M178.906 333.636C178.836 333.42 178.665 333.251 178.448 333.183L177.294 332.82L176.592 331.834C176.46 331.649 176.247 331.539 176.019 331.539C175.792 331.539 175.578 331.649 175.447 331.834L174.744 332.82L173.59 333.183C173.373 333.251 173.203 333.42 173.133 333.636C173.062 333.853 173.101 334.089 173.236 334.272L173.957 335.244L173.945 336.454C173.943 336.682 174.051 336.896 174.235 337.03C174.357 337.118 174.502 337.164 174.648 337.164C174.724 337.164 174.799 337.152 174.872 337.128L176.019 336.743L177.166 337.128C177.382 337.2 177.619 337.163 177.803 337.03C177.987 336.896 178.095 336.682 178.093 336.454L178.082 335.244L178.802 334.272C178.937 334.089 178.976 333.853 178.906 333.636Z",
    fill: "#FFD60D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M178.449 333.183L177.295 332.82L176.593 331.834C176.461 331.649 176.248 331.539 176.021 331.539V336.743L177.168 337.128C177.383 337.2 177.621 337.163 177.805 337.03C177.989 336.896 178.096 336.682 178.094 336.454L178.083 335.244L178.803 334.272C178.939 334.089 178.977 333.853 178.907 333.636C178.837 333.42 178.666 333.251 178.449 333.183Z",
    fill: "#FFB92C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuny);
export default __webpack_public_path__ + "static/media/funy.bacb63dba2aa8b82a9e691b43b2e26e0.svg";
export { ForwardRef as ReactComponent };